import moment from 'moment';
import 'moment-timezone';

angular.module('am4').filter('utcOffset', function() {
    return function(time_zone) {
        return moment().tz(time_zone).format('UTCZ');
    };
});



// WEBPACK FOOTER //
// ./src/app/filters/utcOffset.js